import React, { useEffect, useMemo, useState } from "react";
import { Dialog, IconButton, ThemeProvider } from "@mui/material";
import { Parcel } from "../../../model/parcel";
import { VPUITheme } from "../../../../common/theme/vpui-theme";
import { AnnounceParcelTrackerScanParcel } from "./announce-parcel-tracker-scan-parcel";
import { AnnounceParcelTrackerAssignmentController } from "./announce-parcel-tracker-assignment-controller";
import { AnnounceParcelTrackerContextProvider } from "./announce-parcel-tracker-context";
import { Close } from "@mui/icons-material";

import "./style.scss";

interface IAssignParcelTrackerDialogProps {
    operationCode: string;
    batchId: number;
    parcelList: Parcel[];
    getParcelItemByScan: (parcelId: string) => Parcel | undefined;
    onParcelChanged: () => Promise<void>;
    onFinished: () => void;
}

enum AnnounceParcelTrackerDialogStep {
    ScanParcels,
    TrackerAnnouncement,
}

export const AnnounceParcelTrackerDialog = (props: IAssignParcelTrackerDialogProps) => {
    const [step, setStep] = useState(props.parcelList.length === 0 ?
        AnnounceParcelTrackerDialogStep.ScanParcels : AnnounceParcelTrackerDialogStep.TrackerAnnouncement);
    const [parcelsList, setParcelList] = useState(props.parcelList);
    const isScanMode = useMemo(() => props.parcelList.length === 0, [props.parcelList]);

    const handleParcelTrackerScanned = (value: string) => {
        const item = props.getParcelItemByScan(value);

        if (!item) {
            throw new Error(`Parcel ${value} was not found`);
        }

        setParcelList([item]);
        setStep(AnnounceParcelTrackerDialogStep.TrackerAnnouncement);
    };

    useEffect(() => {
        if (isScanMode) {
            setStep(AnnounceParcelTrackerDialogStep.ScanParcels);
        } else {
            if (parcelsList.length === 0) {
                props.onFinished();
            }
        }
    }, [parcelsList]);

    return <ThemeProvider theme={VPUITheme}>
        <Dialog open={true} onClose={props.onFinished} fullWidth classes={{ paper: "btm-tracker-announce-dialog" }}>
            <div className={"btm-tracker-announce-dialog__close"}>
                <IconButton onClick={props.onFinished}>
                    <Close />
                </IconButton>
            </div>
            {step === AnnounceParcelTrackerDialogStep.ScanParcels &&
                <AnnounceParcelTrackerScanParcel onCompleted={() => setStep(AnnounceParcelTrackerDialogStep.TrackerAnnouncement)}
                                                 onCancel={props.onFinished}
                                                 onParcelScanned={handleParcelTrackerScanned} />}
            {step === AnnounceParcelTrackerDialogStep.TrackerAnnouncement &&
                <AnnounceParcelTrackerContextProvider>
                    <AnnounceParcelTrackerAssignmentController parcelsList={parcelsList}
                                                               onFormSubmit={props.onParcelChanged}
                                                               onClose={props.onFinished} />
                </AnnounceParcelTrackerContextProvider>}
        </Dialog>
    </ThemeProvider>;
};
